import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddSinger from './../dialogs/AddSinger';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import CreatorsDialog from './CreatorsDialog';
import MuvikaService from './../../services/muvika';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Paper from '@mui/material/Paper';
import InfoIcon from '@mui/icons-material/Info';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import PitchButtons from '../items/PitchButtons';
import songbookSessionStore from './../../stores/songbookSession';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import messageStore from './../../stores/message';
import { Views } from './../../enums/enums';
import Link from '@mui/material/Link';
import searchStore from '../../stores/search';
import navigationStore from '../../stores/navigation';

function AddPerformanceSongbook(props) {

  const singerRef = useRef(null);

  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const session = songbookSessionStore((state) => state.session);
  const addSingerLocally = singersStore((state) => state.addSingerLocally);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const setError = messageStore((state) => state.setError);

  const itemsOnPage = 25;
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = searchStore((state) => state.search);
  const setOnlyArtist = searchStore((state) => state.setOnlyArtist);

  const [currentSinger, setCurrentSinger] = useState(null);
  const [lastChosenSinger, setLastChosenSinger] = useState(null);
  const [currentSingerName, setCurrentSingerName] = useState(null);
  const [currentPlayList, setCurrentPlayList] = useState(null);

  const isConsumer = () => {
    if (session) {
      return session.account?.tags?.includes("consumer");
    }
    return null;
  };

  const getInitPitch = () => {
    if (props.track && session.account.tags.includes("consumer")) {
      return props.track.last_pitch ? props.track.last_pitch : 0;
    }
    return 0;
  };

  const [currentPitch, setCurrentPitch] = useState(getInitPitch());
  const [creators, setCreators] = useState(null);
  const [isDefaultSingerSet, setIsDefaultSingerSet] = useState(false);

  const getSingerInOrder = () => {
    if (props.track) {
      let value = props.track.last_singer_id;
      if (value) {
        let singer = props.singers.find(x => x.id == value);
        if (singer) {
          return singer;
        }
      } else {
        if (lastChosenSinger) {
          let singer = props.singers.find(x => x.id == lastChosenSinger.id);
          if (singer) {
            return singer;
          }
        }
      }
      let lastSingerId = props.singers.length > 0 ? props.singers[0].id : null;
      if (lastSingerId) {
        let singer = props.singers.find(x => x.id == lastSingerId);
        if (singer) {
          return singer;
        }
      }
    }
  };

  const selectAll = () => {
    if (singerRef.current) {
      singerRef.current.select();
    }
  };

  const setDefaultSinger = () => {
    if (props.singers && session) {
      let singer = getSingerInOrder();
      setCurrentSinger(singer);
      if (session.account.tags.includes("commercial")) {
        setCurrentSingerName("");
      } else {
        setCurrentSingerName(singer ? singer.name : "");
      }
    }
  };

  useEffect(() => {
    if (isDefaultSingerSet) {
      selectAll();
      setIsDefaultSingerSet(false);
    }
  }, [isDefaultSingerSet]);

  useEffect(() => {
    if (props.open) {
      setDefaultSinger();
      setIsDefaultSingerSet(true);
      setCurrentPitch(getInitPitch());
    }
  }, [props.open]);

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
    setDefaultSinger();
    getCreators();
  }, []);

  const getCreators = () => {
    if (props.track) {
      if (props.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.track.track_id)
          .then(function (res) {
            //console.log(res);
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const [isAddSingerOpen, setIsAddSingerOpen] = useState(false);

  const handleOpenAddSinger = () => {
    setIsAddSingerOpen(true);
  };

  const handleCloseAddSinger = () => {
    setIsAddSingerOpen(false);
  };

  const handlePitchChange = (event, newPitch) => {
    setCurrentPitch(newPitch);
  };

  const singerList = () => {
    if (props.singers) {
      return props.singers.map((singer) =>
        <MenuItem key={singer.id} value={singer.id}>{singer.name}</MenuItem>
      );
    }
  };

  const handleSingerChange = (event) => {
    let singerId = event.target.value;
    let singer = props.singers.find(x => x.id == singerId);
    if (singer) {
      setCurrentSinger(singer);
      setLastChosenSinger(singer);
    }
  };

  const handleSingerSet = (event) => {
    let singerName = event.target.value;
    setCurrentSingerName(singerName);
  };

  const handleSingerCreation = (singerName, gender, email) => {
    if (singerName) {
      singerName = singerName.trim();
      if (singerName.length > 0) {
        MuvikaService.createSinger(sessionToken, singerName, gender, email)
          .then(function (res) {
            if (res.data.data) {
              addSingerLocally(res.data.data);
              if (res.data.data.id) {
                setCurrentSinger(res.data.data);
              } else {
                setError(sessionToken, 0, TR.cm_failed_to_create_singer);
              }
            }
          })
          .catch(function () { });
        setIsAddSingerOpen(false);
      } else {
        setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
      }
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const handleTypedAddPerformance = (pos) => {
    let singerName = currentSingerName;
    if (singerName) {
      singerName = singerName.trim();
      if (singerName.length > 0) {
        MuvikaService.createSinger(sessionToken, singerName, "", "")
          .then(function (res) {
            //console.log(res);
            if (res.data.data) {
              if (!res.data.error) {
                addSingerLocally(res.data.data);
              }
              if (res.data.data.id) {
                setCurrentSinger(res.data.data);
                props.onAddPerformance(res.data.data, currentPitch, currentPlayList, pos);
              } else {
                setError(sessionToken, 0, TR.cm_failed_to_create_singer);
              }
            }
          })
          .catch(function () { });
      } else {
        setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
      }
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const handleAddPerformance = (pos) => {
    if (!isConsumer()) {
      handleTypedAddPerformance(pos);
    } else {
      if (settings.singer_selection === "type") {
        handleTypedAddPerformance(pos);
      } else {
        props.onAddPerformance(currentSinger, currentPitch, currentPlayList, pos);
      }
    }
  };

  const singerForm = () => {
    if (!isConsumer()) {
      return <FormGroup>
        <InputLabel>{TR.cm_singer}</InputLabel>
        <TextField
          inputRef={singerRef}
          className="muvika-dialog-name"
          autoFocus
          onFocus={event => {
            event.target.select();
          }}
          margin="dense"
          type="email"
          fullWidth
          value={currentSingerName}
          onChange={handleSingerSet}
        />
      </FormGroup>;
    } else {
      if (settings) {
        if (settings.singer_selection === "type") {
          return <FormGroup>
            <InputLabel>{TR.cm_singer}</InputLabel>
            <TextField
              inputRef={singerRef}
              className="muvika-dialog-name"
              autoFocus
              onFocus={event => {
                event.target.select();
              }}
              margin="dense"
              type="email"
              fullWidth
              value={currentSingerName}
              onChange={handleSingerSet}
            />
          </FormGroup>;
        }
      }
      if (currentSinger) {
        return <FormGroup>
          <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <Select
                className="muvika-dialog-select"
                labelId="new-singer-label"
                label={TR.cm_singer}
                value={currentSinger.id}
                onChange={handleSingerChange}
              >
                {singerList()}
              </Select>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddSingerButton()}
            </Grid>
          </Grid>
        </FormGroup>;
      } else {
        if (props.singers?.length > 0) {
          return <FormGroup>
            <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
            <Grid container spacing={0}>
              <Grid item xs={10.5}>
                <Select
                  className="muvika-dialog-select"
                  labelId="new-singer-label"
                  label={TR.cm_singer}
                  value={props.singers[0].id}
                  onChange={handleSingerChange}
                >
                  {singerList()}
                </Select>
              </Grid>
              <Grid item xs={1.5}>
                {renderAddSingerButton()}
              </Grid>
            </Grid>
          </FormGroup>;
        } else {
          return <FormGroup>
            <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
            <Grid container spacing={0}>
              <Grid item xs={10.5}>
                <p className="muvika-no-singers">{TR.cm_no_singers}</p>
              </Grid>
              <Grid item xs={1.5}>
                {renderAddSingerButton()}
              </Grid>
            </Grid>
          </FormGroup>;
        }
      }
    }
  };

  const renderAddSingerButton = () => {
    if (isConsumer()) {
      if (settings) {
        if (settings.singer_selection === "list") {
          return <IconButton color="white" className="muvika-dialog-plus-button" component="label" onClick={handleOpenAddSinger}>
            <AddCircleIcon />
          </IconButton>;
        }
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (isAddSingerOpen) {
        handleSingerCreation();
      } else if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      } else {
        handleAddPerformance();
      }
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.Search);
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={() => {
      props.onClose();
    }}>
      <AddSinger open={isAddSingerOpen} isPerformanceAdd={true} onClose={handleCloseAddSinger} onSingerCreation={handleSingerCreation} />
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.track} />
      <DialogContent>
        <img className="muvika-cover-image" src={props.track.url_cover_image} alt="" />
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.track.artist}
          </Link> - {props.track.title} ({props.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
        </h4>

        <Stack spacing={5}>
          {singerForm()}
          <Paper className="muvika-pitch-buttons">
            <p className="muvika-pitch-title">
              {TR.cm_key_pitch}
            </p>
            <PitchButtons value={currentPitch} onPitchChange={handlePitchChange} />
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => {
              handleAddPerformance();
            }}
          >{TR.cm_add_to_queue}
          </Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
};

export default AddPerformanceSongbook;